import { apiRequest } from '@scc/lib'
import type { AdsRepository } from '@/data/repositories/types'
import { toApiDate } from '@/lib/api-date'
import type { DateRange } from '@/modules/shared/types'
import type { AdsDailyMetric } from '@/modules/ads/types'

export function createApiAdsRepository(): AdsRepository {
  return {
    async getDailyMetrics(clientId: string, range: DateRange): Promise<AdsDailyMetric[]> {
      const start = toApiDate(range.from)
      const end = toApiDate(range.to)
      const rows = await apiRequest<AdsDailyMetric[]>(
        `/analytics/ads/daily?start=${start}&end=${end}`,
        { headers: { 'X-Store-Id': clientId } },
      )
      return rows
    },
  }
}

export const adsRepository = createApiAdsRepository()
